module.exports = __webpack_public_path__ + "images/file_icons_v2/bmp-2dc96f02f63ce5efada92075acb0cedf.svg";